import type { FragmentType } from 'src/gql';
import { graphql, unmaskFragment } from 'src/gql';
import { accountSubtitle, accountTitle, renderIconForAccount } from 'src/utils/account';

import { useIsSmallScreen } from '@savvy/deprecated-shared/hooks/use-is-small-screen';

import { ManagedTagIcon } from './icons/managed-tag';
import NetWorthItemDescriptionRow from './views/net-worth-item-description-row';

export const NetWorthAccountDescriptionRowFragment = graphql(/* GraphQL */ `
  fragment NetWorthAccountDescriptionRow on Account {
    __typename
    custody
    ...RenderIconForAccount
    ...AccountTitle
    ...AccountSubtitle
  }
`);
export default function NetWorthAccountDescriptionRow({
  accountFrag,
}: {
  readonly accountFrag: FragmentType<typeof NetWorthAccountDescriptionRowFragment>;
}) {
  const account = unmaskFragment(NetWorthAccountDescriptionRowFragment, accountFrag);
  const isSmallScreen = useIsSmallScreen();
  const icon = (
    <>
      {renderIconForAccount({
        accountFrag: account,
      })}
      {account.custody === 'managed' && (
        <div className="z-[1] -mb-1 -ml-3.5 flex">
          <ManagedTagIcon size={isSmallScreen ? 16 : undefined} />
        </div>
      )}
    </>
  );
  return (
    <NetWorthItemDescriptionRow
      icon={icon}
      subtitle={accountSubtitle({ accountFrag: account })}
      title={accountTitle({ accountFrag: account })}
    />
  );
}
